import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  TESSA_ENVIRONMENTS_DETAIL_PAGE_NAME,
  TESSA_ENVIRONMENTS_INDEX_PAGE_NAME,
  TESSA_ENVIRONMENTS_PLUGIN_ID,
} from '@ns/plugin-ns-tessa-common';
import { Icon, iconPosition } from '@ns/plugin-ns-theme';

import { detailRouteRef, rootRouteRef } from './routes';

const environmentsListPage = PageBlueprint.make({
  name: TESSA_ENVIRONMENTS_INDEX_PAGE_NAME,
  params: {
    icon: <Icon glyph={iconPosition} />,
    loader: () =>
      import('./components/environments-list-page/environments-list-page').then(
        m => <m.EnvironmentsListPage />,
      ),
    path: '/environments',
    routeRef: rootRouteRef,
    title: 'Workspaces',
  },
});

const environmentDetailPage = PageBlueprint.make({
  name: TESSA_ENVIRONMENTS_DETAIL_PAGE_NAME,
  params: {
    loader: () =>
      import(
        './components/environment-detail-page/environment-detail-page'
      ).then(m => <m.EnvironmentDetailPage />),
    path: '/environments/:environmentKey',
    routeRef: detailRouteRef,
    title: 'Workspaces',
  },
});

export default createFrontendPlugin({
  extensions: [environmentsListPage, environmentDetailPage],
  pluginId: TESSA_ENVIRONMENTS_PLUGIN_ID,
  routes: { detail: detailRouteRef, root: rootRouteRef },
});

export { EnvironmentDetailPage } from './components/environment-detail-page/environment-detail-page';
export { EnvironmentsListPage } from './components/environments-list-page/environments-list-page';
